import React from 'react'
import PropTypes from 'prop-types'
import Pagination from 'react-js-pagination'

import { List, Loading, Flex } from '../../views'
import DeviceHistoryItem from './DeviceHistoryBlobItem'

import style from './style.css'

const classnames = require( 'classnames' )
const { Constants : ReduxConstants } = require( '@leverege/api-redux' )

const noItemsView = (
  <Flex className={style.list} align="center" justify="center">
    <div>
      No history items match this query
    </div>
  </Flex>
)

class BlobTableResults extends React.Component {

  static propTypes = {
    results : PropTypes.object,
    onEvent : PropTypes.func.isRequired
  }

  static defaultProps = {
    results : { items : [] }
  }

  static TYPE = 'blob';

  static pageSize = 100;

  constructor( props, context ) {
    super( props, context )

    this.state = {
      activePage : 1
    }
  }

  handlePageChange = ( newPage ) => {
    this.setState( { activePage : newPage } )
  }

  render() {
    const { results, onEvent } = this.props
    const { activePage } = this.state

    let items = results && results.items

    const loading = results.status === ReduxConstants.QUERY_STATUS_LOADING

    const maxRange = results && results.ranges && results.ranges[results.ranges.length - 1] && results.ranges[results.ranges.length - 1][1]
    const itemLength = results && results.items && results.items.length
    if ( maxRange === itemLength ) {
      items = items && [ ...items, { type : 'loadMore' } ]
    }

    const oLength = ( items && items.length ) || 0
    items = items && items.slice( BlobTableResults.pageSize * ( activePage - 1 ), BlobTableResults.pageSize * activePage )

    if ( items && items.length > 0 && items[0] == null ) {
      console.log( items )
    }

    return (
      <div className={style.listContainer}>
        {
          loading ?
            <Loading className={style.list} show /> :
            (
              <List
                className={classnames( style.list )}
                onEvent={onEvent} 
                noItemsView={noItemsView}
                items={items}
                itemView={DeviceHistoryItem}
                itemProps={{ hideNavButtons : false }} />
            )
        }
        <div className={style.pagination}>
          <Pagination
            activePage={activePage}
            itemsCountPerPage={100}
            totalItemsCount={oLength}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange}/>
        </div>
      </div>
    )
  }
}

exports.BlobTableResults = BlobTableResults
